import { FC } from 'react'
import shallow from 'zustand/shallow'
import { Cascader } from 'antd'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { Country } from '../../types'
import { useScoreGridsStore } from './ScoreGridsStore'
import PerFlexRow from '../../components/custom_components/FlexRow'
import { searchOptionsFilter } from '../../components/custom_components/Cascader/util'
import { useCascaderSearchOnOpen } from '../../components/custom_components/Cascader/useCascaderSearchOnOpen'

export const ScoreGridsPageSelector: FC = () => {
  const { t } = useTranslation()
  const [companiesAndCountriesSelected, selected, setSelected, isProcessingExport] = useScoreGridsStore(
    (state) => [state.companiesAndCountriesSelected, state.selected, state.setSelected, state.isProcessingExport],
    shallow,
  )

  const { cascaderRef, cascaderClassName, searchPlaceholder, onPopupVisibleChange } = useCascaderSearchOnOpen(
    t('scoreGridsView.companyOrCountryCascaderSearchPlaceholder'),
  )

  const onDropDownChanged = (value: string[]) => {
    if (value && value.length === 2) {
      setSelected(value[0], value[1] as Country)
    }
  }

  return (
    <>
      <BackgroundBox noPadding r color="white75" mb="m" className="per-tabbarContent--height">
        <PerFlexRow align="middle" className="per-tabbarContent--height">
          <Cascader
            ref={cascaderRef}
            className={cascaderClassName}
            options={companiesAndCountriesSelected}
            onChange={onDropDownChanged}
            placeholder={searchPlaceholder}
            allowClear={false}
            defaultValue={[selected.companyId, selected.country]}
            value={[selected.companyId, selected.country]}
            style={{ width: '500px', marginLeft: '3.5px' }}
            disabled={isProcessingExport}
            showSearch={{ filter: searchOptionsFilter }}
            onPopupVisibleChange={onPopupVisibleChange}
          />
        </PerFlexRow>
      </BackgroundBox>
    </>
  )
}
